import axios from "axios";
import moment from "moment";
import getParameterByName from "../../../Functions/functions";
const roleName = getParameterByName("roleName");
const status = getParameterByName("status");
export const getAllInvoiceDetailByInvoiceIdV2 = async (
  setFormState,
  setMultipleData,
  Invoice_id,
  setTaxFormState,
  setImportPaymentDetail,
  role,
  setDataLoading,
  setIsParallel
) => {
  const data = {
    InvoiceId: Invoice_id,
  };
  setDataLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/getAllInvoiceDataByInvoiceIdV2`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      setDataLoading(false);
       const mappedAgreementDetails = (res?.data?.agreement_Detail || [])?.map((item) => ({
  agreementStartDate: item.AgreementStartDate || "",
  agreementEndDate: item.AgreementEndDate || "",
  tenure: Number(item.Tenure) || 0,
  rentPerMonth: Number(item.RentPerMonth) || 0,
  totalPayment: Number(item.TotalPayment) || 0,
  annuallyIncrease: Number(item.AnnuallyIncrease) || 0,
  stampDuty: Number(item.StampDuty) || 0,
}));
      const invoiceDetail = res.data?.invoice_Details[0];
      // SkipTaxStep
      let invoice_Payment = {};
      if (res?.data?.paymentDetail?.length > 0) {
        invoice_Payment = res?.data?.paymentDetail[0];
        invoice_Payment.dueOn = new Date(invoice_Payment?.dueOn)
          ?.toISOString()
          .split("T")[0];
      }

      const updatedPOData = res?.data?.poData.map((item) => ({
        ...item,
        inpuT_QTY: Number(item.inpuT_QTY) || Number(item.INPUT_QTY),
        inpuT_VAL: Number(item.inpuT_VAL) || Number(item.INPUT_VAL),
      }));
      setMultipleData((setMultipleData) => ({
        ...setMultipleData,
        glAccount: res?.data?.glAccount || [],
        paymentDetail: res?.data?.paymentDetail || [],
        // invoice_Payment: res?.data?.paymentDetail[0] || [],
        invoice_Payment: invoice_Payment || [],
        invoice_Details: res?.data?.invoice_Details[0] || [],
        efdv_Invoices: res?.data?.efdv_Invoices || [],
        erf_ExpenseInvoice_Detail: res?.data?.pitStop || [],
        fer_Invoice_Detial: res?.data?.fer || [],
        // paymentMethod: res?.data?.paymentMethod || [],
        // paymentMethodSupp: res?.data?.paymentMethodSupp || [],
        // poData: res?.data?.poData || [],
        poData: updatedPOData || [],

        vendorTaxDetail: res?.data?.vendorTaxDetail || [],
      }));
      const finded = res?.data?.vendorTaxDetail?.vendorTax?.find(
        (x) => x.invoice_Id === Invoice_id
      );
      const newData = [];
      for (let i = 0; i < res?.data?.glAccount?.length; i++) {
        let obj = res?.data?.glAccount[i];
        let obj1 = {};

        obj1.rowId = Math.random();
        obj1.accountId = obj?.AccountId || 0;
        obj1.invoice_Id = Invoice_id || 0;
        obj1.glAccount = obj?.GLAccount || "";
        obj1.costCenter = obj?.CostCenter;
        // obj1.costCenter = { CostCenterCode: obj?.CostCenter || "" };
        obj1.accountType = obj?.AccountType || "";
        obj1.amount = Number(obj?.Amount) || 0;
        obj1.costCenterOwner = obj?.CostCenterOwner || "";
        obj1.CostCenterOwnerName = obj?.CostCenterOwnerName || "";
        obj1.costCenterOwnerName = obj?.CostCenterOwnerName || "";
        obj1.stCode = obj?.StCode || "";
        obj1.order = obj?.Order || "";
        obj1.profitCenter = Number(obj?.ProfitCenter) || "";
        obj1.wbsElement = obj?.WBSElement || "";
        obj1.created_By = obj?.Created_By || "";
        obj1.created_On = obj?.Created_On || new Date();
        obj1.updated_By = obj?.Updated_By || "";
        obj1.updated_On = obj?.Updated_On || new Date();
        obj1.fixedAsset = obj?.FixedAsset || "";
        obj1.tType = obj?.TType || "";
        obj1.description = obj?.Description || "";
        obj1.expenseDate = obj?.ExpenseDate || new Date();
        obj1.horizonId = obj?.HorizonId || "";
        obj1.department = obj?.Department || "";
        obj1.vendorCode = obj?.VendorCode || "";
        obj1.vendor_Code = obj?.VendorCode || "";
        obj1.CustomerAccountNo= obj?.CustomerAccountNo || "";
        obj1.fsDocDate =
          moment(obj?.FSDocDate)?.format("YYYY-MM-DD") || new Date();
        obj1.fsDocNo = obj?.FSDocNo || "";
        newData.push(obj1);
      }
      const glDefaultRow = {
        rowId: Math.random(),
        accountId: 0,
        invoice_Id: Invoice_id,
        glAccount: "",
        costCenter: "",
        accountType: "",
        amount: 0,
        costCenterOwner: "",
        stCode: "",
        order: "",
        profitCenter: "",
        wbsElement: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        fixedAsset: "",
        tType: "",
        description: res.data?.invoice_Details[0]?.Invoice_Desc,
        expenseDate: "",
        horizonId: "",
        department: "",
        vendorCode: "",
      };
      if (res?.data?.glAccount.length === 0 && res?.data?.invoice_Details[0]?.PO_Based === "False") {
        newData.push(glDefaultRow);
      }
      const isTaxAmt = isNaN(Number(finded?.salesTaxAmount));
      const clearingvendor = [];
      for (let i = 0; i < res?.data?.clearingVendorDetail?.length; i++) {
        let object = res?.data?.clearingVendorDetail[i];

        let vendorObj = {};
        vendorObj.vendor_Code = {
          Vendor_Code: object.VendorCode,
        };
        vendorObj.vendor_Name = object.vendor_Name;
        vendorObj.amount = Number(object.Amount);
        clearingvendor.push(vendorObj);
      }

      // const poData = res?.data?.poData || [];
      // const newItem = {};
      // for (const item of poData) {
      //    newItem = {
      //     ...item, // Copy all properties from the original item
      //     INPUT_QTY: parseInt(item.INPUT_QTY),
      //     INPUT_VAL: parseInt(item.INPUT_VAL),
      //   };
      // }
      if (role === "APS") {
        setFormState((formState) => ({
          ...formState,
          invoice_TaxDetails: res?.data?.vendorTaxDetail?.taxDetail || [],
          taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [],
          // invoicePORef_List: res?.data?.poData || [],
          invoicePORef_List: updatedPOData || [],
          invoice_Accounts: newData || [],
          invoice_Accounts_list: res?.data?.glAccount || [], // used at reviewer screen for gl_table.
          salesTaxAmount: isTaxAmt ? "" : finded?.salesTaxAmount || "",
          salesTaxCode: finded?.salesTaxCode || "",
          invoiceDebugData_List: res?.data?.debugData || [],
          invoice_Payment: invoice_Payment,
          invoice_Payment_Details: res?.data?.paymentDetail,
          fsDocumentDate: res.data?.invoice_Details[0]?.FSDocumentDate || "",
          fsDocumentNumber:
            res.data?.invoice_Details[0]?.FSDocumentNumber || "",
          vendor_Details: clearingvendor,
           Agreement_Details : mappedAgreementDetails || [],
           distributor_Code : res.data?.invoice_Details[0]?.Distributor_Code || "",
          FCA_Details : res?.data?.fcaDetail || [],
          provinceDuty : res?.data?.provinceDuty || [],
 stamp_Duty_Calculations : res?.data?.stampDuty || [],
          // invoice_Payment: res?.data?.paymentDetail?.[0],

          // invoice_Accounts: res?.data?.glAccount, //for gl_table
        }));
      } else {
        setFormState((formState) => ({
          ...formState,
          taxCard_List:  res?.data?.vendorTaxDetail?.taxDetail || [],
          taxCard_ListCheck: res?.data?.vendorTaxDetail?.taxDetail || [],
          invoice_TaxDetails: res?.data?.vendorTaxDetail?.taxDetail || [],
          // invoicePORef_List: res?.data?.poData || [],
          invoicePORef_List: updatedPOData || [],
          invoice_Accounts: newData || [],
          invoice_Accounts_list:
            role === "HR"
              ? newData
              : res?.data?.glAccount?.length > 0
              ? res?.data?.glAccount
              : [glDefaultRow], // used at reviewer screen for gl_table.
          salesTaxAmount: isTaxAmt ? "" : finded?.salesTaxAmount || "",
          salesTaxCode: finded?.salesTaxCode || "",
          invoiceDebugData_List: res?.data?.debugData || [],
          fsDocumentDate: res.data?.invoice_Details[0]?.FSDocumentDate || "",
          fsDocumentNumber:
            res.data?.invoice_Details[0]?.FSDocumentNumber || "",
          vendor_Details: clearingvendor,
           Agreement_Details : mappedAgreementDetails || [],
          FCA_Details : res?.data?.fcaDetail || [],
          provinceDuty : res?.data?.provinceDuty || [],
 stamp_Duty_Calculations : res?.data?.stampDuty || [],
          // invoice_Payment: res?.data?.paymentDetail?.[0],
          // invoice_Accounts: res?.data?.glAccount, //for gl_table
          // invoice_Details: res?.data?.invoice_Details[0] || [],
          // invoice_Payment: invoice_Payment,
        }));

        if (setIsParallel !== undefined) {
           setIsParallel(res.data?.invoice_Details[0].isParallel === "True" ? "Parallel" : "Sequential")
        }
        if (
          invoiceDetail.SkipTaxStep !== "True" ||
          status === "SendToIPFromSupervisor"
        ) {
          const tempObj = {
            category: "",
            purchaseType: "",
            supplierJurisdiction: "",
            supplierType: "",
            status: "",
            fillingStatus: "",
            goodsNature: "",
            taxType: "",
            taxCode: "",
            amount: invoiceDetail?.invoice_Amount,
          };
          setFormState((formState) => ({
            ...formState,
            taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [tempObj],
            taxCard_ListCheck: res?.data?.vendorTaxDetail?.taxDetail || [
              tempObj,
            ],
          }));
        }
      }

      setTaxFormState((taxFormState) => ({
        ...taxFormState,
        salesTaxCode: finded?.salesTaxCode || "",
        salesTaxAmount: finded?.salesTaxAmount || "",
        taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [],
        // additionalDocIds:res?.data?.additionalDocIds.split(" "),
        // comments:res?.data?.comments
      }));
      if (res?.data?.paymentDetail.length > 0) {
        const paymentData = [];
        for (let index = 0; index < res?.data?.paymentDetail.length; index++) {
          const item = res?.data?.paymentDetail[index];
          item.postingKey=item?.ReferencePostingKey!==''?item?.ReferencePostingKey:item?.postingKey;
          item.rowId = Math.random();
          item.individualPayee =
            item.individualPayee.toLowerCase() === "true" ? true : false;
          paymentData.push(item);
        }

        setImportPaymentDetail((importPaymentDetail) => ({
          ...importPaymentDetail,
          invoice_Payment_Details: paymentData,
        }));
      }
      // setTaxFormState(res.data)
    })
    .catch((err) => {});
};
export const GetBatchInvoiceDetailsWithname = async (
  setTaxFormState,
  setImportPaymentDetail,
  setMultipleData,
  invoicePayload,
  role,
  setFormState,
  setDataLoading,
  setPoBasedState
) => {
  const data = {
    invoice_id: invoicePayload?.Invoice_id,
  };
  setDataLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/VFTreasury/GetBatchInvoiceDetailsWithname`,
    // url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getInvoiceByIdRoleWise`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      setDataLoading(false);
       const mappedAgreementDetails = (res?.data?.agreement_Detail || [])?.map((item) => ({
  agreementStartDate: item.AgreementStartDate || "",
  agreementEndDate: item.AgreementEndDate || "",
  tenure: Number(item.Tenure) || 0,
  rentPerMonth: Number(item.RentPerMonth) || 0,
  totalPayment: Number(item.TotalPayment) || 0,
  annuallyIncrease: Number(item.AnnuallyIncrease) || 0,
  stampDuty: Number(item.StampDuty) || 0,
}));
      const resData = res?.data?.eeP_I2P_Invoice_Details_List[0];
      const response = res?.data?.eeP_I2P_Invoice_Processing_List[0];
      const vendorRes = res?.data?.eeP_I2P_Vendor_List?.[0];

      const multi_attach = res?.data?.additional_Attachment?.map((item) => {
        return {
          ...item,
          path: item?.fPath + item?.fileName || "",
        };
      });
      const invoice_attach = res?.data?.attachment?.map((item) => {
        return {
          ...item,
          path: item?.fPath + item?.fileName || "",
        };
      });

      const startDate = moment(resData?.invoice_Date);
      const endDate = moment();

      let invoice_Payment = {};
      if (res?.data?.paymentDetail?.length > 0) {
        invoice_Payment = res?.data?.paymentDetail[0];
        invoice_Payment.dueOn = new Date(invoice_Payment?.dueOn)
          ?.toISOString()
          .split("T")[0];
      }
      const finded = res?.data?.vendorTaxDetail?.vendorTax?.find(
        (x) => x.invoice_Id === invoicePayload?.Invoice_id
      );

      const newData = [];
      for (let i = 0; i < res?.data?.glAccount?.length; i++) {
        let obj = res?.data?.glAccount[i];
        let obj1 = {};

        obj1.rowId = Math.random();
        obj1.accountId = obj?.AccountId || 0;
        obj1.invoice_Id = obj?.Invoice_Id || 0;
        obj1.glAccount = obj?.GLAccount || "";
        obj1.costCenter = obj?.CostCenter;
        // obj1.costCenter = { CostCenterCode: obj?.CostCenter || "" };
        obj1.accountType = obj?.AccountType || "";
        obj1.amount = Number(obj?.Amount) || 0;
        obj1.costCenterOwner = obj?.CostCenterOwner || "";
        obj1.CostCenterOwnerName = obj?.CostCenterOwnerName || "";
        obj1.stCode = obj?.StCode || "";
        obj1.order = obj?.Order || "";
        obj1.profitCenter = Number(obj?.ProfitCenter) || "";
        obj1.wbsElement = obj?.WBSElement || "";
        obj1.created_By = obj?.Created_By || "";
        obj1.created_On = obj?.Created_On || new Date();
        obj1.updated_By = obj?.Updated_By || "";
        obj1.updated_On = obj?.Updated_On || new Date();
        obj1.fixedAsset = obj?.FixedAsset || "";
        obj1.tType = obj?.TType || "";
        obj1.description = obj?.Description || "";
        obj1.expenseDate = obj?.ExpenseDate || new Date();
        obj1.horizonId = obj?.HorizonId || "";
        obj1.department = obj?.Department || "";
        obj1.vendorCode = obj?.VendorCode || "";
        obj1.fsDocDate =
          moment(obj?.FSDocDate)?.format("YYYY-MM-DD") || new Date();
        obj1.fsDocNo = obj?.FSDocNo || "";

        newData.push(obj1);
      }

      const updatedPOData = res?.data?.eeP_I2P_Invoice_PO_Ref_List.map(
        (item) => ({
          ...item,
          inpuT_QTY: Number(item.inpuT_QTY) || Number(item.INPUT_QTY),
          inpuT_VAL: Number(item.inpuT_VAL) || Number(item.INPUT_VAL),
        })
      );
      // Calculate the number of days between the two dates
      const daysBetween = endDate.diff(startDate, "days");
      const daysToSalesTax = 180 - daysBetween;
      const isTaxAmt = isNaN(Number(finded?.salesTaxAmount));
      const clearingvendor = [];
      for (
        let i = 0;
        i < res?.data?.eeP_I2P_Invoice_ClearingVendor_list?.length;
        i++
      ) {
        let object = res?.data?.eeP_I2P_Invoice_ClearingVendor_list[i];

        let vendorObj = {};
        vendorObj.vendor_Code = {
          Vendor_Code: object.vendorCode,
        };
        vendorObj.vendor_Name = object.vendor_Name;
        vendorObj.amount = Number(object.amount);
        clearingvendor.push(vendorObj);
      }

      setMultipleData((setMultipleData) => ({
        ...setMultipleData,
        glAccount: res?.data?.glAccount || [],
        paymentDetail: res?.data?.paymentDetail || [],
        // invoice_Payment: res?.data?.paymentDetail[0] || [],
        invoice_Payment: invoice_Payment || [],
        // invoice_Details: res?.data?.invoice_Details[0] || [],
        efdv_Invoices: res?.data?.efdv_Invoices || [],
        erf_ExpenseInvoice_Detail: res?.data?.pitStop || [],
        fer_Invoice_Detial: res?.data?.fer || [],
        // paymentMethod: res?.data?.paymentMethod || [],
        // paymentMethodSupp: res?.data?.paymentMethodSupp || [],
        // poData: res?.data?.eeP_I2P_Invoice_PO_Ref_List || [],
        poData: updatedPOData || [],
        vendorTaxDetail: res?.data?.vendorTaxDetail || [],
      }));
      if (role?.roleName === "IP") {

    
        setFormState((formState) => ({
          ...formState,
          vP_InvoiceId:resData.vP_InvoiceId,
          isInitiator: resData?.isInitiator || false,
          searchWith: resData?.searchWith,
          isDeptCordinator: resData?.isDeptCordinator ? true : false,
          isHR: resData?.isHR || false,
          isPCDV: resData?.isPCDV || false, // EFDV initiator
          isVPPayment: resData?.isVPPayment || false,
          isVFPayment: resData?.isVFPayment || false,
          isSubmittedByVendor: resData?.isSubmittedByVendor || false,
          isImport: resData?.isImport || false,
          isLogistics: resData?.isLogistics || false,
          pO_Based: resData?.pO_Based,
          isPSID: resData?.isPSID || false,
          psid: resData?.psid,
          urgent: resData?.urgent,
          skipTaxStep: resData?.skipTaxStep,
          courier_Tracking_No: resData?.courier_Tracking_No,
          daysto_sale_taxlapse: daysToSalesTax,
          // LogisticInvoices: false,
          // VendorPrePayment: false,
          // VendorFinancingPayment: false,
          invoice_Id: invoicePayload?.Invoice_id,
          pO_No: resData?.pO_No,
          pcdvLocation: resData?.pcdvLocation,
          po_Date : resData?.po_Date,
          plant_Code:resData?.plant_Code , 
          pcdvSegment: resData?.pcdvSegment,
          grn_No: resData?.grn_No,
          delv_Note_No: resData?.delv_Note_No,
          loam_approver: resData?.loam_approver,
          barcode_No: resData?.barcode_No,
          demandType: resData?.demandType,
          invoice_Type: resData?.invoice_Type,
          invoice_No: resData?.invoice_No,
          salesTaxAmount: isTaxAmt ? "" : finded?.salesTaxAmount || "",
          salesTaxCode: finded?.salesTaxCode,
          invoiceCategory: resData?.invoiceCategory,
          invoice_Desc: resData?.invoice_Desc,
          invoice_Amount: resData?.invoice_Amount,
          invoice_Amount_formatted: resData?.invoice_Amount?.toLocaleString(),
          final_Invoice_Amount: resData?.final_Invoice_Amount,
          dept_coordinator: resData?.dept_coordinator,
          grn_No: resData?.grn_No,
          irUser: resData?.irUser,
          ipUser: resData?.ipUser,
          taxTeam: resData?.taxTeam,
          due_Date : resData?.due_Date ,
          paymentTerm : resData?.paymentTerm, 
               Agreement_Details : mappedAgreementDetails|| [],
          FCA_Details : res?.data?.fcaDetail || [],
          provinceDuty : res?.data?.provinceDuty || [],
 stamp_Duty_Calculations : res?.data?.stampDuty || [],
 stampDuty : res?.data?.stampDuty || 0,
          // vendor_Code: resData?.vendor_Code,
          // vendor_Code: resData?.pO_Based
          //   ? resData?.vendor_Code
          //   : {
          //       Vendor_Code: resData?.vendor_Code,
          //       Vendor_Name: res?.data?.vendor_Name?.vendor_Name,
          //     },
          vendor_Code: resData?.pO_Based
            ? resData?.vendor_Code
            : {
                Vendor_Code: vendorRes?.Vendor_Code,
                Vendor_Name: vendorRes?.Vendor_Name,
                Designation:vendorRes?.Designation,
                Department:vendorRes?.Department
              },
          // invoice_Date: resData?.invoice_Date.slice(0, -9),
          invoice_Date: moment(resData?.invoice_Date).format("YYYY-MM-DD"),
          vendor_Name:
            (vendorRes?.Vendor_Code || "") +
            "-" +
            (vendorRes?.Vendor_Name || "")+
            "-" +
            (vendorRes?.Designation || "")+
            "-" +
            (vendorRes?.Department || ""),
          // vendor_Name: resData?.vendor_Name,
          lineManager: resData?.lineManager,
          directorHR: resData?.directorHR,
          sharedServices: resData?.sharedServices,
          invoice_attachment: invoice_attach[0],
          additionalDocIds: multi_attach, // paths
          comments: "",
          invoice_Payment: invoice_Payment,
          invoice_Payment_Details:  (res?.data?.paymentDetail || []).map((item) => ({
          ...item,
          postingKey: item?.ReferencePostingKey,
        })),
          invoice_Accounts: newData || [],
          invoice_Accounts_list: res?.data?.glAccount || [],
          taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [],
          taxCard_ListCheck: res?.data?.vendorTaxDetail?.taxDetail || [],
          invoice_TaxDetails: res?.data?.vendorTaxDetail?.taxDetail || [],
          // invoicePORef_List: res?.data?.eeP_I2P_Invoice_PO_Ref_List || [],
          invoicePORef_List: updatedPOData || [],

          // invoiceDebugData_List: res?.data?.debugData || [],
          fsDocumentDate: resData?.FSDocumentDate || "",
          fsDocumentNumber: resData?.FSDocumentNumber || "",
          vendor_Details: clearingvendor,
          firstClearText: res?.data?.inv_prc?.firstClearingText,
          secondClearText: res?.data?.inv_prc?.secondClearingText,
          distributor_Code : resData?.distributor_Code || "",

          // invoice_Accounts_list: [
          //   {
          //     glAccount: "",
          //     costCenter: "",
          //     costCenterOwner: "",
          //     costCenterOwnerName: "",
          //     horizonId: "",
          //     vendorCode: "",
          //     amount: 0,
          //     profitCenter: "",
          //     department: "",
          //   },
          // ],
          // Expense_Accounts_list: [
          //   // Invoice_Accounts_list for back-end
          //   {
          //     expenseDate: "",
          //     description: "",
          //     amount: 0,
          //     glAccount: "",
          //     costCenter: "",
          //     fixedAsset: "",
          //     tType: "",
          //     profitCenter: "",
          //     costCenterOwner: "",
          //     costCenterOwnerName: "",
          //     horizonId: "",
          //     vendorCode: "",
          //     department: "",
          //   },
          // ],
          // Invoice_Clearingvendor_list: [
          //   {
          //     vendorCode: "",
          //     VendorName: "",
          //     amount: "",
          //   },
          // ],
          // verified: false,
        }));
      } else {

        setFormState((formState) => ({
          ...formState,
          vP_InvoiceId:resData?.vP_InvoiceId,
          isInitiator: resData?.isInitiator,
          searchWith: resData?.searchWith,
          isDeptCordinator: resData?.isDeptCordinator ? true : false,
          isHR: resData?.isHR || false,
          isPCDV: resData?.isPCDV, // EFDV initiator
          isVPPayment: resData?.isVPPayment,
          isVFPayment: resData?.isVFPayment,
          isSubmittedByVendor: resData?.isSubmittedByVendor,
          isImport: resData?.isImport,
          isLogistics: resData?.isLogistics,
          courier_Tracking_No: resData?.courier_Tracking_No,
          pO_Based: resData?.pO_Based,
          po_Date : resData?.po_Date,
          plant_Code:resData?.plant_Code , 
          isPSID: resData?.isPSID,
          pcdvLocation: resData?.pcdvLocation,
          pcdvSegment: resData?.pcdvSegment,
          psid: resData?.psid,
          urgent: resData?.urgent,
          skipTaxStep: resData?.skipTaxStep,
          daysto_sale_taxlapse: daysToSalesTax,
          invoice_Id: invoicePayload?.Invoice_id,
          pO_No: resData?.pO_No,
          grn_No: resData?.grn_No,
          delv_Note_No: resData?.delv_Note_No,

          barcode_No: resData?.barcode_No,
          demandType: resData?.demandType,
          invoice_Type: resData?.invoice_Type,
          invoice_No: resData?.invoice_No,
          loam_approver: resData?.loam_approver,
          logisticsTeam: resData?.logisticsTeam,

          invoiceCategory: resData?.invoiceCategory,
          invoice_Desc: resData?.invoice_Desc,
          invoice_Amount: resData?.invoice_Amount,
          invoice_Amount_formatted: Number(
            resData?.invoice_Amount
          )?.toLocaleString(),
          final_Invoice_Amount: resData?.final_Invoice_Amount,
          dept_coordinator: resData?.dept_coordinator,
          irUser: resData?.irUser,
          ipUser: resData?.ipUser,
          // resData?.ipUser || role?.roleName === "IR" ? user?.LoginId : "",
          taxTeam: resData?.taxTeam,
          due_Date : resData?.due_Date ,
          paymentTerm : resData?.paymentTerm, 
//Rent case of dept coordinator get mapping
               Agreement_Details : mappedAgreementDetails|| [],
          FCA_Details : res?.data?.fcaDetail || [],
          provinceDuty : res?.data?.provinceDuty || [],
 stamp_Duty_Calculations : res?.data?.stampDuty || [],
 stampDuty : res?.data?.stampDuty || 0,
          // vendor_Code: "",
          // vendor_Code: resData?.vendor_Code,
          vendor_Code: resData?.pO_Based
            ? resData?.vendor_Code
            : {
                Vendor_Code: vendorRes?.Vendor_Code,
                Vendor_Name: vendorRes?.Vendor_Name,
                Designation:vendorRes?.Designation,
                Department:vendorRes?.Department
              },
          // invoice_Date: resData?.invoice_Date.slice(0, -9),
          invoice_Date: moment(resData?.invoice_Date).format("YYYY-MM-DD"),
          vendor_Name:
            (vendorRes?.Vendor_Code || "") +
            "-" +
            (vendorRes?.Vendor_Name || "")+
            "-" +
            (vendorRes?.Designation || "")+
            "-" +
            (vendorRes?.Department || ""),
          // invoice_Date: resData?.invoice_Date?.slice(0, -9),
          invoice_Date: moment(resData?.invoice_Date).format("YYYY-MM-DD"),
          lineManager: resData?.lineManager,
          directorHR: resData?.directorHR,
          sharedServices: resData?.sharedServices,
          invoice_attachment: invoice_attach[0],
          additionalDocIds: multi_attach, // paths

          //  invoice_attachment:invoice_attach ,
          currency: response?.currency,
          fiscal_Year: response?.fiscal_Year,
          posting_Date: response?.posting_Date,
          document_No: response?.saP_Posting_Id,
          documents_Reference:
            res?.data?.eeP_I2P_Invoice_ClearingDetail_List[0]?.referenceNo,
          newInvoice_Desc: response?.newInvoice_Desc,
          invoice_Payment: invoice_Payment,
          invoice_Payment_Details:
            role?.roleName === "AP Supervisor" ?  (res?.data?.paymentDetail || []).map((item) => ({
              ...item,
              postingKey: item?.ReferencePostingKey,
            })) : [],

          invoice_Accounts: newData || [],
          invoice_Accounts_list: res?.data?.glAccount || [],
          taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [],
          taxCard_ListCheck: res?.data?.vendorTaxDetail?.taxDetail || [],
          invoice_TaxDetails: res?.data?.vendorTaxDetail?.taxDetail || [],
          // invoicePORef_List: res?.data?.eeP_I2P_Invoice_PO_Ref_List || [],
          invoicePORef_List: updatedPOData || [],
          salesTaxAmount: isTaxAmt ? "" : finded?.salesTaxAmount || "",
          salesTaxCode: finded?.salesTaxCode || "",
          // invoiceDebugData_List: res?.data?.debugData || [],
          fsDocumentDate: resData?.FSDocumentDate || "",
          fsDocumentNumber: resData?.FSDocumentNumber || "",
          vendor_Details: clearingvendor,
          firstClearText: res?.data?.inv_prc?.firstClearingText,
          secondClearText: res?.data?.inv_prc?.secondClearingText,
          distributor_Code : resData?.distributor_Code || "",
          // comments: resData?.comments,
          // rtbId: resData?.rtbId || "",
        }));
      }
      setTaxFormState((taxFormState) => ({
        ...taxFormState,
        salesTaxCode: finded?.salesTaxCode || "",
        salesTaxAmount: finded?.salesTaxAmount || "",
        taxCard_List: res?.data?.vendorTaxDetail?.taxDetail || [],
        // additionalDocIds:res?.data?.additionalDocIds.split(" "),
        // comments:res?.data?.comments
      }));
      setImportPaymentDetail((importPaymentDetail) => ({
        ...importPaymentDetail,
        invoice_Payment_Details: [...res?.data?.paymentDetail],
      }));
      setPoBasedState(resData?.pO_Based === true ? "PO" : "Non-PO");
    })
    .catch((err) => {});
};
